import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Session } from '@models/account';
import { SESSION_KEY } from '@utils/constants/storage';

export interface Redirection {
    should: boolean;
    path: string;
}

interface RedirectProps {
    shouldRedirect: (account: Session) => Redirection;
}

function parseJSON(json: string | null): unknown {
    if (json) {
        try {
            return JSON.parse(json);
        } catch {
            return null;
        }
    }
    return null;
}

const Redirect = ({ shouldRedirect, children }: PropsWithChildren<RedirectProps>) => {
    const navigate = useNavigate();

    useEffect(() => {
        const sessionData = localStorage.getItem(SESSION_KEY);
        const account = parseJSON(sessionData) as Session;
        const redirect = shouldRedirect(account);
        if (redirect.should) navigate(redirect.path, { replace: true });
    }, [shouldRedirect, navigate]);

    return <>{children}</>;
};

export default Redirect;
